function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("circle", {
  cx: 50,
  cy: 50,
  fill: "none",
  "ng-attr-stroke": "{{config.color}}",
  "ng-attr-stroke-width": "{{config.width}}",
  "ng-attr-r": "{{config.radius}}",
  "ng-attr-stroke-dasharray": "{{config.dasharray}}",
  stroke: "#d3cece",
  strokeWidth: 10,
  r: 35,
  strokeDasharray: "164.93361431346415 56.97787143782138"
}, React.createElement("animateTransform", {
  attributeName: "transform",
  type: "rotate",
  calcMode: "linear",
  values: "0 50 50;360 50 50",
  keyTimes: "0;1",
  dur: "1s",
  begin: "0s",
  repeatCount: "indefinite"
}));

var SvgLoading = function SvgLoading(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    className: "lds-rolling",
    style: {
      backgroundImage: "none",
      backgroundPosition: "initial initial",
      backgroundRepeat: "initial initial"
    }
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/loading.2af9fb25.svg";
export { SvgLoading as ReactComponent };